import { PureComponent } from "react";

import yup from "utilities/form/yup";

import { BTAlert } from "commonComponents/btWrappers/BTAlert/BTAlert";
import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    type GridColumn,
    GridColumnType,
    type IClientGridColumn,
} from "commonComponents/utilities/Grid/GridContainer.types";

type PhoneCellType = string | undefined;

class PhoneCell extends PureComponent<
    IGridCellRenderProps<PhoneCellType, GridColumn<PhoneCellType>>
> {
    render() {
        const { cellValue, column, isInEdit } = this.props;
        return !isInEdit ? (
            <a href={`tel:${cellValue}`}>{cellValue}</a>
        ) : (
            <BTAlert
                message={`Unimplemented Edit control:'${column.columnType}', value:${JSON.stringify(
                    cellValue,
                )}`}
                type="warning"
                data-testid="phoneUnimplementedEditControl"
            />
        );
    }
}

export const columnPhone: IClientGridColumn<PhoneCellType> = {
    validationSchema: yup.string(),
    columnType: GridColumnType.phoneNumber,

    // todo: BTLink
    // todo: talk to UX, should we denote this is a tel link with a phone icon?
    Cell: PhoneCell,
};
